module.exports = __webpack_public_path__ + "img/5-2.a1456934.png";